import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerPropretyInfo: {
      display: "flex",
      gap: "32px",
      flexDirection: "row",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    containerPropretyDetailTimeLine: {
      display: "flex",
      flexDirection: "row",
      gap: "24px",
      width: "100%",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
    containerSecCol: {
      display: "flex",
      flexDirection: "column",
      flex: "0.253",
      gap: "32px",
    },
    containerFirstCol: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      flex: "0.747",
    },
  };
});
